export const REWARD_SHARE_IMAGE_PATH =
  '/media/lip-sync-demo-poster-768.jpg'

export const REWARD_X_CARD_VERSION = 'v2'

export function resolveRewardShareSiteUrl(value) {
  try {
    const url = new URL(String(value || '').trim())
    return `${url.origin}/`
  } catch {
    return 'https://lip-sync.ai/'
  }
}

export function resolveRewardShareImageUrl(value, siteUrl) {
  try {
    return new URL(String(value || '').trim()).href
  } catch {
    try {
      return new URL(REWARD_SHARE_IMAGE_PATH, resolveRewardShareSiteUrl(siteUrl)).href
    } catch {
      return `https://lip-sync.ai${REWARD_SHARE_IMAGE_PATH}`
    }
  }
}

export function resolveRewardShareImageType(value) {
  try {
    const pathname = new URL(String(value || '').trim()).pathname.toLowerCase()
    if (pathname.endsWith('.png')) return 'image/png'
    if (pathname.endsWith('.webp')) return 'image/webp'
    return 'image/jpeg'
  } catch {
    return 'image/jpeg'
  }
}

export function resolveXRewardShareUrl(value, now = new Date()) {
  try {
    const url = new URL(resolveRewardShareSiteUrl(value))
    const shareDay = now.toISOString().slice(0, 10).replace(/-/g, '')
    url.searchParams.set('share', `x-${REWARD_X_CARD_VERSION}-${shareDay}`)
    return url.href
  } catch {
    return resolveRewardShareSiteUrl(value)
  }
}
